module.exports = "/static/assets/f3ecdd3dd85577dcae7b23c83ecbda1d.svg";